import apiClient from "./axios-client";

/**
 * getPropertyDetails
 * @returns
 */
export const getPropertyDetails = async (propertyNumber) => {
  const response = await apiClient.get(
    `property/getBasicPropertyDetails?propertyCode=${propertyNumber}`
  );
  return response.data;
};

/**
 * update mobile or email
 * @returns
 */
export const updatePropertyDetails = async (body) => {
  const response = await apiClient.post(
    `property/add-mobileno-to-property`,
    body
  );
  return response.data;
};

/**
 * get property details using UPICID
 * @returns
 */
export const getPropertyByUPICID = async (body) => {
  const response = await apiClient.post(`property/getPropertyByUPICID`, body);
  return response.data;
};

/**
 * get property details using By Mobile Or Property No
 * @returns
 */
export const getPropertyByMobileOrPropertyNo = async (body) => {
  const response = await apiClient.post(
    `property/getPropertyByMobileOrPropertyNo`,
    body
  );
  return response.data;
};

/**
 * get property details By Marathi
 * @returns
 */
export const getPropertyByMarathiName = async (body) => {
  const response = await apiClient.post(
    `property/getPropertyByMarathiName`,
    body
  );
  return response.data;
};